// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__TXMZK","selected":"Chip_selected__1wGsM"};